<template>
    <div class="comment__more" :id="comment.id" @click="commentActionsShow = !commentActionsShow">
        <div class="comment__more-icon"></div>
        <div class="comment-actions" v-if="commentActionsShow" v-click-outside="commentActions">
            <div class="comment-actions__inner">
                <div @click="edit" v-if="comment.belongsToUser" class="comment-actions__item comment-actions__item-edit">
                    Изменить
                </div>
                <div @click="remove" v-if="comment.belongsToUser" class="comment-actions__item comment-actions__item-delete">
                    Удалить
                </div>
                <div @click="complain" class="comment-actions__item comment-actions__item-complain" v-if="!comment.belongsToUser">
                    Пожаловаться
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        START_COMMENT_EDITING_ACTION,
        DELETE_COMMENT_ACTION,
        COMPLAIN_ON_COMMENT_ACTION
    } from "VueApps/comments/actions/actions";

    export default {
        name: "MoreActionsBtn",
        props: {
            comment: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                commentActionsShow: false
            }
        },
        methods: {
            commentActions() {
                this.commentActionsShow = false;
            },
            edit: function () {
                this.$store.dispatch(START_COMMENT_EDITING_ACTION, {
                    commentId: this.comment.id,
                });
            },
            remove: function () {
                this.$store.dispatch(DELETE_COMMENT_ACTION, {
                    commentId: this.comment.id,
                });
            },
            complain: function () {
                this.$store.dispatch(COMPLAIN_ON_COMMENT_ACTION, {
                    commentId: this.comment.id,
                });
            }
        }
    }
</script>

<style scoped>

</style>
